export function googleLogin() {
  return new Promise((resolve, reject) => {
    if(!gapi) return reject(new Error("Google API is not loaded"));
    gapi.auth2.authorize(gapiClient, function(response) {
      if (response && !response.error) {
        resolve(response);
      } else {
	var error = new Error("Could not log in");
        error.response = response;
        reject(error);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./app/javascript/gateway/google.js